var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("위 대화에서, 속뜻이 궁금한 말풍선에 손가락으로 동그라미를 그려주세요.")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){_vm.$emit('refreshCanvas')}}},[_c('i',{staticClass:"fa fa-undo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-button',{attrs:{"to":{name:'writeQuestion'}}},[_vm._v("다음")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df61443e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostQuestion/Annotate.vue
// module id = MJqk
// module chunks = 1